import FadeIn from './FadeIn'

export default FadeIn
